<template>
  <div class="review">
    <el-card shadow="never" class="review-card">
      <div class="filter-bar">
        <span class="filter-label">专区类型:</span>
        <el-radio-group v-model="reviewType" size="small" @change="handleTypeChange">
          <el-radio-button :label="1">甄选专区</el-radio-button>
          <el-radio-button :label="3">臻赏专区</el-radio-button>
          <el-radio-button :label="4">爆品专区</el-radio-button>
        </el-radio-group>
        <span class="filter-divider"></span>
        <span class="filter-label">筛选状态:</span>
        <el-radio-group v-model="reviewFilter" size="small" @change="fetchReviews">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="0">待审核 ({{ pendingCount }})</el-radio-button>
          <el-radio-button label="1">已通过</el-radio-button>
          <el-radio-button label="2">已驳回</el-radio-button>
        </el-radio-group>
      </div>

      <el-table :data="reviewList" style="width: 100%;" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="100" />
        <el-table-column prop="name" label="商品名" min-width="200" />
        <el-table-column prop="branch" label="所属分身" width="150">
          <template slot-scope="scope">
            <span class="branch-name">{{ scope.row.branch }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="售价(365n)" width="130">
          <template slot-scope="scope">
            <span class="price-bold">¥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="提报时间" width="180">
          <template slot-scope="scope">{{ scope.row.submitTime | formatDateTime }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === '待审核' ? 'danger' : scope.row.status === '已通过' ? 'success' : 'info'"
              size="small"
            >
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">查看详情</el-button>
            <template v-if="scope.row.status_code === 0">
              <el-button type="text" style="color: #67c23a;" size="small" @click="handleAudit(scope.row, 'approve')">审核通过</el-button>
              <el-button type="text" style="color: #E4393C;" size="small" @click="handleAudit(scope.row, 'reject')">驳回</el-button>
            </template>
            <span v-else class="processed-text">已处理</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <span>共 {{ total }} 条记录</span>
        <el-pagination
          background layout="prev, pager, next"
          :total="total" :page-size="limit"
          :current-page.sync="page"
          @current-change="fetchReviews"
        />
      </div>
    </el-card>

    <!-- 商品审核详情 -->
    <el-dialog title="商品审核详情" :visible.sync="detailVisible" width="900px" top="6vh">
      <div v-loading="detailLoading" class="detail-body">
        <template v-if="detail">
          <el-divider content-position="left">基本信息</el-divider>
          <div class="detail-base">
            <el-image
              :src="detail.goods_img"
              class="detail-main-img"
              fit="cover"
              :preview-src-list="[detail.goods_img]"
            />
            <el-descriptions :column="2" size="small" border class="detail-desc">
              <el-descriptions-item label="商品ID">{{ detail.id }}</el-descriptions-item>
              <el-descriptions-item label="专区类型">{{ detail.goods_type_text }}</el-descriptions-item>
              <el-descriptions-item label="商品名称" :span="2">{{ detail.goods_name }}</el-descriptions-item>
              <el-descriptions-item label="所属分身">{{ detail.branch_name }}</el-descriptions-item>
              <el-descriptions-item label="所属分类">{{ detail.category_name || '-' }}</el-descriptions-item>
              <el-descriptions-item label="售价(365n)">
                <span class="price-red">¥{{ detail.price_min }}</span>
                <span v-if="detail.price_max !== detail.price_min"> ~ <span class="price-red">¥{{ detail.price_max }}</span></span>
              </el-descriptions-item>
              <el-descriptions-item label="库存">{{ detail.stock }}</el-descriptions-item>
              <el-descriptions-item label="上架状态">{{ detail.status_text }}</el-descriptions-item>
              <el-descriptions-item label="提报时间">{{ detail.create_time | formatDateTime }}</el-descriptions-item>
            </el-descriptions>
          </div>

          <el-divider content-position="left">审核信息</el-divider>
          <el-descriptions :column="2" size="small" border>
            <el-descriptions-item label="审核状态">
              <el-tag :type="auditTagType(detail.audit_status)" size="small">{{ detail.audit_status_text }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="最后更新">{{ detail.update_time | formatDateTime }}</el-descriptions-item>
            <el-descriptions-item v-if="detail.audit_note" label="驳回原因" :span="2">
              <span class="reject-note">{{ detail.audit_note }}</span>
            </el-descriptions-item>
          </el-descriptions>

          <el-divider content-position="left">规格与库存（共 {{ detail.sku_count }} 条规格）</el-divider>
          <el-table :data="detail.skus" border size="small">
            <el-table-column label="规格图" width="72">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.sku_img"
                  :src="scope.row.sku_img"
                  style="width: 40px; height: 40px; border-radius: 4px;"
                  fit="cover"
                  :preview-src-list="[scope.row.sku_img]"
                />
                <span v-else class="processed-text">-</span>
              </template>
            </el-table-column>
            <el-table-column prop="spec_name_text" label="规格组合" min-width="150" />
            <el-table-column label="售价" width="100">
              <template slot-scope="scope"><span class="price-red">¥{{ scope.row.price }}</span></template>
            </el-table-column>
            <el-table-column label="原价" width="100">
              <template slot-scope="scope">¥{{ scope.row.market_price }}</template>
            </el-table-column>
            <el-table-column label="成本价" width="100">
              <template slot-scope="scope">¥{{ scope.row.cost_price }}</template>
            </el-table-column>
            <el-table-column prop="stock" label="库存" width="80" />
            <el-table-column prop="sales" label="销量" width="80" />
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">{{ scope.row.status_text }}</el-tag>
              </template>
            </el-table-column>
          </el-table>

          <template v-if="detail.goods_slide.length > 0">
            <el-divider content-position="left">商品轮播图</el-divider>
            <div class="img-list">
              <el-image
                v-for="(url, idx) in detail.goods_slide"
                :key="'slide-' + idx"
                :src="url"
                class="detail-thumb"
                fit="cover"
                :preview-src-list="detail.goods_slide"
              />
            </div>
          </template>

          <template v-if="detailImages.length > 0">
            <el-divider content-position="left">商品详情图</el-divider>
            <div class="img-list">
              <el-image
                v-for="(url, idx) in detailImages"
                :key="'detail-' + idx"
                :src="url"
                class="detail-thumb"
                fit="cover"
                :preview-src-list="detailImages"
              />
            </div>
          </template>
        </template>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
        <template v-if="detail && detail.audit_status === 0">
          <el-button type="danger" @click="handleAudit({ id: detail.id }, 'reject', true)">驳回</el-button>
          <el-button type="success" @click="handleAudit({ id: detail.id }, 'approve', true)">审核通过</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getReviews, getReviewDetail, approveReview, rejectReview } from '@/api'

export default {
  name: 'Review',
  data() {
    return {
      reviewType: 1,
      reviewFilter: '',
      reviewList: [],
      total: 0,
      page: 1,
      limit: 10,
      pendingCount: 0,
      loading: false,
      // 详情弹窗
      detailVisible: false,
      detailLoading: false,
      detail: null
    }
  },
  computed: {
    // 详情富文本中的图片地址
    detailImages() {
      return this.extractDetailImages(this.detail ? this.detail.content : '')
    }
  },
  mounted() {
    this.fetchReviews()
  },
  methods: {
    handleTypeChange() {
      this.page = 1
      this.reviewFilter = ''
      this.fetchReviews()
    },
    fetchReviews() {
      this.loading = true
      const params = { page: this.page, limit: this.limit, goods_type: this.reviewType }
      if (this.reviewFilter !== '') params.audit_status = this.reviewFilter

      getReviews(params).then(res => {
        this.reviewList = res.list || []
        this.total = res.total || 0
        this.pendingCount = res.pendingCount || 0
      }).catch(() => {
        this.$message.error('获取审核列表失败')
      }).finally(() => {
        this.loading = false
      })
    },
    openDetail(row) {
      this.detailVisible = true
      this.fetchDetail(this.parseGoodsId(row.id))
    },
    fetchDetail(goodsId) {
      if (!goodsId) return
      this.detailLoading = true
      getReviewDetail(goodsId).then(res => {
        this.detail = res
      }).catch(() => {
        this.$message.error('获取商品详情失败')
        this.detailVisible = false
      }).finally(() => {
        this.detailLoading = false
      })
    },
    // 列表返回的 id 形如 R-12，详情接口需要纯数字
    parseGoodsId(id) {
      if (typeof id === 'number') return id
      return parseInt(String(id).replace('R-', ''), 10)
    },
    // 从详情富文本中提取图片地址
    extractDetailImages(content) {
      if (!content) return []
      const imgs = []
      const regex = /<img[^>]+src="([^">]+)"/g
      let match
      while ((match = regex.exec(content)) !== null) {
        imgs.push(match[1])
      }
      return imgs
    },
    auditTagType(status) {
      if (status === 0) return 'danger'
      if (status === 1) return 'success'
      return 'info'
    },
    handleAudit(row, action, fromDetail = false) {
      const actionText = action === 'approve' ? '通过' : '驳回'
      this.$confirm(`确认${actionText}该商品？`, '审核确认', {
        type: action === 'approve' ? 'success' : 'warning'
      }).then(() => {
        const goodsId = this.parseGoodsId(row.id)
        const apiCall = action === 'approve'
          ? approveReview({ id: goodsId })
          : rejectReview({ id: goodsId })

        apiCall.then(() => {
          this.$message.success(`已${actionText}`)
          this.fetchReviews()
          // 详情弹窗内操作时保持弹窗打开并刷新，便于确认最新审核状态
          if (fromDetail) {
            this.fetchDetail(goodsId)
          }
        }).catch(() => {
          this.$message.error(`${actionText}失败`)
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.review-card { border-radius: 8px; }
.filter-bar { display: flex; align-items: center; gap: 16px; padding: 0 0 16px; border-bottom: 1px solid #f0f0f0; margin-bottom: 16px; }
.filter-label { font-size: 14px; color: #606266; font-weight: 500; }
.filter-divider { width: 1px; height: 20px; background: #e4e7ed; }
.branch-name { color: #409EFF; }
.price-bold { font-weight: bold; }
.price-red { font-weight: bold; color: #E4393C; }
.processed-text { color: #c0c4cc; }
.reject-note { color: #E4393C; }
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: 16px 0 0; font-size: 13px; color: #909399; }
/* 详情弹窗 */
.detail-body { max-height: 68vh; overflow-y: auto; padding-right: 8px; }
.detail-base { display: flex; gap: 16px; align-items: flex-start; }
.detail-main-img { width: 160px; height: 160px; border-radius: 6px; flex-shrink: 0; border: 1px solid #ebeef5; }
.detail-desc { flex: 1; }
.detail-thumb { width: 90px; height: 90px; border-radius: 6px; border: 1px solid #ebeef5; }
.img-list { display: flex; flex-wrap: wrap; gap: 8px; }
</style>
